import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setLogoutHandler } from '../libs/authEvents';
import axiosInstance from '../libs/axios';

export default function useAuth() {
  const [token, setToken] = useState(() => {
    try {
      return localStorage.getItem('token');
    } catch (_e) {
      return null;
    }
  });
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    try {
      // Revoke DATEV refresh token via backend endpoint
      try {
        const response = await axiosInstance.post('/auth/logout');
        if (response.data?.datev_token_revoked) {
          console.log('[LOGOUT] DATEV refresh token revoked successfully');
        } else if (response.data?.message) {
          console.log(`[LOGOUT] ${response.data.message}`);
        }
      } catch (error) {
        // Don't block logout if DATEV revoke fails
        console.warn('[LOGOUT] Failed to revoke DATEV token, but continuing with logout:', error?.response?.data?.detail || error.message);
      }
    } catch (_e) {
      // Continue with logout even if API call fails
    }
    
    try {
      // Clear user-specific localStorage items
      localStorage.removeItem('token');
      localStorage.removeItem('selectedDatevClient');
    } catch (_e) {}
    setToken(null);
    navigate('/login');
  }, [navigate]);

  // Register logout handler for axios interceptor
  useEffect(() => {
    setLogoutHandler(logout);
    return () => setLogoutHandler(null);
  }, [logout]);

  const login = useCallback((t) => {
    try {
      // Clear previous user's data before setting new token
      localStorage.removeItem('selectedDatevClient');
      localStorage.setItem('token', t);
    } catch (_e) {}
    setToken(t);
    navigate('/');
  }, [navigate]);

  return { token, login, logout };
}
